import React from 'react';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import { listPartners } from './partnersData';
import OverviewLayout from '../OverviewLayout/OverviewLayout';
import PartnerCard from './PartnerCard/PartnerCard';

import './Partners.scss';

const Partners = () => {
  const history = useHistory();

  return (
    <OverviewLayout>
      <Helmet>
        <title>Partners | The Host Co</title>
      </Helmet>

      <div className="Partners_wrapper">
        <h4>Partners</h4>
        <section className="Partners">
          {listPartners.map(({ key, description, image, action }) => {
            return (
              <PartnerCard
                key={key}
                image={image}
                copy={description}
                onContinue={() => action(history)}
              />
            );
          })}
        </section>
      </div>
    </OverviewLayout>
  );
};

export default Partners;
